module.exports = __webpack_public_path__ + "static/img/btn3_hover.3a2f2c48.png";